module.exports = __webpack_public_path__ + "static/media/bh_logo.6094979d.png";